<template>
  <div
    class="loginPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="form_wrap">
      <div class="head_wrap flex-colc">
        <p class="iconfont icon-huiyuanzhucedengluguanli"></p>
        <h1 class="flex-rowc">Register | Be a Cooperative Partner</h1>
      </div>
      <div class="form_box">
        <el-form label-width="95px" label-position="left" class="demo-ruleForm">
          <div class="form_country">
            <p>Set Your Business Area ( Country/Location )</p>
            <div class="radio_wrap flex-rowc">
              <div
                class="radio_item flex-rowl"
                v-for="(item, index) in COUNTRYLIST"
                :key="index"
                :class="{
                  active:
                    ruleForm.countryids
                      .split(',')
                      .indexOf(item.countryid.toString()) > -1,
                }"
                @click="handleCountry(item)"
              >
                <div class="radio flex-rowl">
                  <span class="iconfont icon-quanxuan"></span>
                  <img style="width: 26px; height: 17px" :src="item.icon" />
                  {{
                    item.countryname_e ? item.countryname_e : item.countryname
                  }}
                </div>
              </div>
            </div>
          </div>
          <el-form-item class="form_item form_tel_item flex-rowc">
            <p class="mark">*</p>
            <!-- 区号 -->
            <div class="code_tel_num flex-rowl">
              <i class="iconfont icon-shouji"></i>
              <span>+ {{ ruleForm.countryids == 2 ? 7 : (ruleForm.countryids == 3 ? 1 : (ruleForm.countryids == 8 ? 1 : 86)) }}</span>
            </div>
            <el-input
              v-model="ruleForm.linkphone"
              placeholder="PHONE NUMBER"
            ></el-input>
            <p class="tip">
              Numerals only, 16 digits maximum. <br />
              Please enter your real contact information, <br />
              For the authenticity verification for you.
            </p>
          </el-form-item>
          <el-form-item class="form_item flex-rowc">
            <p class="mark">*</p>
            <el-input
              v-model="ruleForm.username"
              placeholder="CREATE YOUR ID"
              @input="handleInput"
              maxlength="30"
            ></el-input>
            <p class="tip">
              Numbers and letters, no special symbols,<br />
              30 words maximum.
            </p>
          </el-form-item>
          <el-form-item class="form_item flex-rowc">
            <p class="mark">*</p>
            <el-input v-model="ruleForm.email" placeholder="EMAIL"></el-input>
          </el-form-item>
          <el-form-item class="form_item flex-rowc">
            <p class="mark">*</p>
            <el-input v-model="ruleForm.pwd" placeholder="PASSWORD"></el-input>
            <p class="tip">
              Numbers and letters, no special symbols,<br />
              20 words maximum.
            </p>
          </el-form-item>
          <el-form-item class="form_item flex-rowc">
            <p class="mark">*</p>
            <el-input
              v-model="pwd2"
              placeholder="ENTER PASSWORD AGAIN TO CONFIRM"
            ></el-input>
            <p class="tip">
              Please make sure the passwords<br />
              entered twice are consistent
            </p>
          </el-form-item>
          <div class="form_User">
            <p>You Want to Register as</p>
            <div class="radio_wrap flex-rowc">
              <div
                class="radio flex-rowl"
                v-for="(item, index) in userattrArr"
                :class="{ active: ruleForm.userattr == item.value }"
                :key="index"
                @click="handleUserAttr(item)"
              >
                <span class="iconfont icon-quanxuan"></span> {{ item.label }}
              </div>
            </div>
            <div
              class="form_item flex-rowc"
              v-if="ruleForm.userattr == '企业or机构合作'"
            >
              <p class="mark">*</p>
              <el-input
                v-model="ruleForm.qyname"
                placeholder="COMPANY OR AGENCY’S NAME"
              ></el-input>
            </div>
          </div>

          <div class="form_User">
            <p>Got Recommendation？</p>
            <div class="radio_wrap flex-rowc">
              <div
                class="radio flex-rowl"
                v-for="(item, index) in recommendCodeList"
                :class="{ active: isRecommend === item.value }"
                :key="index"
                @click="handleRecommendCode(item)"
              >
                <span class="iconfont icon-quanxuan"></span> {{ item.txt }}
              </div>
            </div>
            <div class="form_item flex-rowc" v-if="isRecommend == 1">
              <p class="mark">*</p>
              <el-input
                v-model="recommendCode"
                placeholder="COMPANY OR AGENCY’S NAME"
              ></el-input>
              <i class="iconfont icon-wenhao" @click="handleTip"></i>
            </div>
            <div class="tip" v-if="isShowTip">
              Recommendation code can be obtained from designated suppliers.
              <br />
              If you have no recommendation code, please select "NO" or contact
              customer service for details. <br />
              have no recommendation code will not affect normal use.
            </div>
          </div>
          <div class="verify_wrap flex-rowl">
            <div class="verify-input flex-rowc">
              <el-form-item label="" label-width="70px">
                <el-input
                  v-model="verifyCode"
                  placeholder="Verification code"
                  @keyup.enter.native="submitForm('ruleForm')"
                ></el-input>
              </el-form-item>
            </div>
            <VerifyCode
              key="verify-code-1"
              @code-changed="handleCodeChanged1"
            />
          </div>
        </el-form>
        <div
          class="submit flex-rowc"
          @click="submitForm('ruleForm')"
          v-loading.fullscreen.lock="fullscreenLoading"
        >
          CONFIRM
        </div>
        <!-- <div class="copy_wrap flex-colc">
          <div class="tip">Technology By</div>
          <el-image
            style="width: 150px; height: 16px"
            :src="require('@/assets/images/publice_logo.png')"
          ></el-image>
        </div> -->
      </div>
    </div>
  </div>
</template>
  <script>
import { mapState } from "vuex";
import { specialUserLogin, specialUserReg } from "../api/api";
import VerifyCode from "../components/VerifyCode.vue"; // 引入 VerifyCode 组件
export default {
  name: "register",
  //import引入的组件需要注入到对象中才能使用
  components: { VerifyCode },
  data() {
    return {
      fullscreenLoading: false,
      numCode: "",

      ruleForm: {
        username: "",
        pwd: "",
        usertype: "overseas", // 用户类型 =overseas=海外用户 ai=AI用户
        truename: "",
        countryids: "", // 责任区域（国家） id
        email: "",
        specialtype: "合作用户", // 特别用户类型 =合作用户 直属用户
        userattr: "", // 用户属性 =个人合作 企业or机构合作
        qyname: "",
        linkphone: "",
        limittype: 2, // 用户基础权限类型 =1=业务员管理 2=受限用户 3=游客
        useridentity: "普通用户", // 用户身份 =经销商 合作买手 普通用户
      },
      // 是否加入推荐码
      isRecommend: "",
      // 推荐码
      recommendCode: "",
      // 推荐码列表
      recommendCodeList: [
        { value: 1, txt: "YES" },
        { value: 2, txt: "NO" },
      ],
      isShowTip: false,
      pwd2: "", // 确认密码
      verifyCode: "", // 验证码
      userattrArr: [
        {
          label: "Personal User",
          value: "个人合作",
        },
        {
          label: "Company or Agency",
          value: "企业or机构合作",
        },
      ],
      countryidsArr: [], // 责任区域（国家） id

      loading: false,
      isShow: false,

      showCountryList: false,
      selectedCountryIndex: 0, // 默认选中中国
      countries: [],
    };
  },
  computed: {
    ...mapState(["COUNTRYLIST"]),
  },
  created() {},
  mounted() {
    this.drawCode([]);
  },
  methods: {
    // 用户属性
    handleUserAttr(item) {
      this.ruleForm.userattr = item.value;
    },
    // 推荐码
    handleRecommendCode(item) {
      this.isRecommend = item.value;
    },
    // 提示
    handleTip() {
      this.isShowTip = !this.isShowTip;
    },
    // 选择国家
    handleCountry(item) {
      if (this.countryidsArr.includes(item.countryid)) {
        // 如果 countryidsArr 中存在 item.countryid，则移除它
        this.countryidsArr = this.countryidsArr.filter(
          (id) => id != item.countryid
        );
      } else {
        // 如果 countryidsArr 中不存在 item.countryid，则添加它
        this.countryidsArr = [item.countryid];
        // this.countryidsArr.push(item.countryid);
      }

      this.ruleForm.countryids = this.countryidsArr.join(",");
    },
    handleInput() {
      // 正则表达式，匹配数字和字母，不包含特殊符号。使用replace
      this.ruleForm.username = this.ruleForm.username.replace(
        /[^\w]/g,
        ""
      )
    },
    handleCodeChanged1(code) {
      this.numCode = code;
    },

    submitForm() {
      let { username, linkphone, email, pwd, userattr, qyname, countryids } =
        this.ruleForm;
      let { pwd2, verifyCode, numCode } = this;

      if (countryids == "") {
        this.$message.warning("Please select country");
        return;
      }
      if (linkphone == "") {
        this.$message.warning("Please enter your phone number");
        return;
      }
      if (username == "") {
        this.$message.warning("Please enter your username");
        return;
      }
      if (email == "") {
        this.$message.warning("Please enter your email");
        return;
      }
      if (pwd == "") {
        this.$message.warning("Please enter your password");
        return;
      }
      if (pwd2 == "") {
        this.$message.warning("Please enter your password again");
        return;
      }
      if (pwd != pwd2) {
        this.$message.warning("The two passwords entered are inconsistent");
        return;
      }
      if (userattr == "") {
        this.$message.warning("Please select user attribute");
        return;
      }
      if (userattr == "企业or机构合作") {
        if (qyname == "") {
          this.$message.warning("Please enter your company or agency name");
          return;
        }
      }

      if (verifyCode == "") {
        this.$message.warning("Please enter the verification code");
        return;
      }
      if (verifyCode != numCode) {
        this.$message.warning("The verification code is incorrect");
        return;
      }
      this.ruleForm.truename = username;
      this.fullscreenLoading = true;
      specialUserReg(this.ruleForm).then((res) => {
        if (res.result) {
          // this.userSubmit(this.formName)
          this.$message.success(
            "Congratulations, the registration is successful"
          );
          setTimeout(() => {
            this.$router.push("/login");
          }, 1500);
        } else {
          this.$message.warning(res.message);
        }
        this.fullscreenLoading = false;
      });
      // this.userSubmit(this.formName);
    },
    // 登录接口
    userSubmit(params) {
      specialUserLogin(params).then((res) => {
        if (res.result == "True") {
          let message = this.$message({
            message: this.$t("Login successful"),
            center: true,
            type: "success",
          });
          this.$store.commit("updateToken", res.token);
          this.fullscreenLoading = false;
          setTimeout(() => {
            this.$router.push("/home");
            message.close();
          }, 1500);
        } else {
          this.$message.error(
            res.msg == "登录失败"
              ? this.$t("Account or password error")
              : this.$t(
                  "The function is temporarily unavailable, please try again later"
                )
          );
          this.fullscreenLoading = false;
        }
      });
    },

  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll); //销毁滚动事件
  },
};
</script>
  <style lang="less" scoped>
.loginPage {
  .head_title {
    height: 30px;
    background: #e6e6e6;
    font-size: 12px;
    color: #666666;
    letter-spacing: 1px;
    font-family: "MontserratExtraLight", sans-serif; /* 使用引入的字体 */
    padding-left: 30px;
    box-sizing: border-box;
  }
  .form_wrap {
    position: relative;
    padding: 40px 0 180px;
    box-sizing: border-box;
    .head_wrap {
      margin-bottom: 45px;
      p {
        font-size: 42px;
        margin-bottom: 15px;
      }
      h1 {
        font-size: 30px;
        color: #333333;
        font-weight: 400;
      }
    }
    .form_box {
      margin: auto;
      .form_item {
        position: relative;

        p {
          font-size: 16px !important;
          color: #ff0000 !important;
          position: absolute;
          white-space: nowrap;
          top: 50%;
          transform: translateY(-50%);
          line-height: 20px;
          &.mark {
            left: -15px;
          }
          &.tip {
            left: 517px;
          }
        }
        .icon-wenhao {
          font-size: 24px;
          margin-left: 10px;
          color: #2c2c2c;
          cursor: pointer;
        }
        &.form_tel_item {
          margin-bottom: 60px;
          /deep/ .el-form-item__content {
            display: flex;
            .code_tel_num {
              font-size: 20px;
              color: #333333;
              margin-right: 35px;
              .iconfont {
                font-size: 30px;
                margin-right: 5px;
              }
            }
            .el-input {
              flex: 1;
            }
          }
        }
      }

      .submit {
        width: 310px;
        height: 45px;
        border-radius: 45px;
        background: #000000;
        font-size: 16px;
        color: #ffffff;
        margin: auto;
        font-family: "MontserratRegular", sans-serif; /* 使用引入的字体 */
        letter-spacing: 1px;
        cursor: pointer;
      }
      .form-item {
        position: relative;
        .input_btn {
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          padding: 0 20px;
        }
      }
      .form_User {
        p {
          font-size: 30px;
          color: #333333;
          text-align: center;
        }
        .radio_wrap {
          margin: 40px auto 30px;
        }
        .tip {
          font-size: 14px;
          color: #777777;
          text-align: center;
          margin-top: 10px;
        }
        .form_item {
          width: 500px;
          margin: auto;
        }
      }
      .form_country {
        margin: 60px 100px 40px;
        p {
          font-size: 30px;
          color: #333333;
          text-align: center;
          margin-bottom: 20px;
        }
        .radio_wrap {
          flex-wrap: wrap;
          .radio_item {
            min-width: 200px;
            height: 50px;
            border-radius: 25px;
            border: 2px solid #f3f3f3;
            padding-left: 11px;
            box-sizing: border-box;
            margin-right: 30px;
            margin-bottom: 20px;
            img {
              margin-right: 5px;
            }
            &:last-child {
              margin-right: 0;
            }
            &.active {
              border: 2px solid #033333;
              .icon-quanxuan {
                color: #595a5a;
              }
            }
          }
        }
      }
      .verify_wrap {
        width: 500px;
        margin: 50px auto 40px;
        .el-form-item {
          margin-bottom: 0;
          /deep/.el-form-item__content {
            width: 340px;
          }
        }
        .verify-code {
          width: 160px;
          .verify-code-change {
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
      .radio {
        font-size: 16px;
        color: #333333;
        margin-right: 40px;
        position: relative;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        .icon-quanxuan {
          font-size: 28px;
          margin-right: 7px;
          color: #bbbbbb;
        }
        &.active {
          .icon-quanxuan {
            color: #595a5a;
          }
        }
      }
      .copy_wrap {
        padding: 60px 0 100px;
        .tip {
          font-size: 12px;
          color: #333333;
          margin-bottom: 10px;
        }
      }
      /deep/.el-form-item__content {
        margin-left: 0 !important;
        width: 500px;
      }
      /deep/.el-input__inner {
        border-radius: 45px;
      }
    }
  }
}
</style>